<template>
  <svg
    class="lock-icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <!-- shackle -->
    <path
      d="M8 10.5V7.25a4 4 0 0 1 8 0v3.25"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <!-- body -->
    <rect
      x="4.5"
      y="10.5"
      width="15"
      height="10"
      rx="2.5"
      stroke="currentColor"
      stroke-linejoin="round"
    />
    <!-- keyhole -->
    <path
      d="M12 14.25v2.5"
      stroke="currentColor"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "LockIcon",
};
</script>

<style scoped>
/* scales with the surrounding text and follows the current theme colour.
   stroke-width lives in CSS so small instances can compensate for the scale
   down: the stroke shrinks with the viewBox, 2 at 12px renders thinner than
   the same 2 at 17px in the header */
.lock-icon {
  width: 1em;
  height: 1em;
  flex: none;
  color: inherit;
  stroke-width: 2;
}
</style>
